import { CdekCalculateInfo } from '@shared/types/cdek';
import FetchData from '@shared/utils/fetchData/fetchData';

import { CdekCalculateRequest } from './types';

export const cdekCalculate = async (body: CdekCalculateRequest) => {
  const res = await FetchData.post<CdekCalculateInfo>('v2/delivery/calculate', {
    body: JSON.stringify({ ...body })
  });

  return res.data;
};
